<template>
    <div class="driver-account-page">
        <template v-if="mixinUserInfo.platformType != 1">
            <div class="formTitle">账户信息</div>
            <Card header="司机钱包">
                <el-form label-width="100px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="账户余额">
                                <div> {{ (info.balance || 0) + (info.noBalance || 0) }}元</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="可提现余额">
                                <div> {{ info.balance || 0 }}元</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="冻结中余额">
                                <div>{{ info.noBalance || 0 }}元</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="提现账户">
                                <span v-if="info.alipayAccount">{{ info.alipayAccount || '-' }} ｜ {{ info.alipayRealName
                                    || '-' }}</span>
                                <span v-else class="util-remark">暂未绑定</span>
                                <el-button type="text" size="medium" @click="showEditDialog"
                                    v-if="btnPreFn('driver_edit_withdrawal', false)">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>
        </template>
        <div class="dz-page" v-else>
            <el-descriptions :column="2" label-position="left" label-width="120px" size="medium" border
                style="margin-bottom: 16px;">
                <el-descriptions-item label="账户余额">
                    <div> {{ (info.balance || 0) + (info.noBalance || 0) }}元 | {{ info.balance || 0 }}元可提现</div>
                </el-descriptions-item>
                <el-descriptions-item label="提现账户">
                    <span v-if="info.alipayAccount">{{ info.alipayAccount || '-' }} ｜ {{ info.alipayRealName
                        || '-' }}</span>
                    <span v-else class="util-remark">暂未绑定</span>
                    <el-button type="text" size="medium" @click="showEditDialog"
                        v-if="btnPreFn('driver_edit_withdrawal', false)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                </el-descriptions-item>
            </el-descriptions>

            <driverRechargeList :driverData="info" :hideTitle="true"></driverRechargeList>
        </div>


        <!-- 修改提现账户弹窗 -->
        <el-dialog title="提现账户" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" label-position="left">
                <el-form-item label="支付宝账户" prop="alipayAccount">
                    <el-input v-model="form.alipayAccount" placeholder="请输入支付宝账户" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="账户姓名" prop="alipayRealName">
                    <el-input v-model="form.alipayRealName" placeholder="请输入账户姓名" maxlength="10"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="medium" @click="dialogVisible = false">取消</el-button>
                    <el-button size="medium" type="primary" @click="handleSubmit" :loading="loading">提交</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import driverRechargeList from '../../driverRechargeList.vue'
export default {
    components: {
        driverRechargeList
    },
    name: 'DriverAccountPage',
    props: {
        info: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {

            dialogVisible: false,
            form: {
                alipayAccount: "",
                alipayRealName: ""
            },
            rules: {
                alipayAccount: [
                    { required: true, message: '请输入支付宝账户', trigger: ['blur', 'change'] }
                ],
                alipayRealName: [
                    { required: true, message: '请输入账户姓名', trigger: ['blur', 'change'] }
                ]
            },
            loading: false
        }
    },
    computed: {
        maskAlipayAccount() {
            return this.$utils.maskPhone(this.info.alipayAccount)
        },
        maskName() {
            return this.$utils.maskName(this.info.alipayRealName)
        }
    },
    methods: {
        showEditDialog() {
            this.form.alipayAccount = this.info.alipayAccount
            this.form.alipayRealName = this.info.alipayRealName
            this.dialogVisible = true
        },
        async handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    let url = "/api/v1/manage/driver/alipayBind";
                    let params = {
                        driverId: this.info.id,
                        account: this.form.alipayAccount,
                        realName: this.form.alipayRealName
                    }
                    let { code } = await this.$axios.put(url, params);
                    if (code === 1) {
                        this.$message.success("修改成功");
                        this.dialogVisible = false;
                        this.$emit('refresh');
                    }
                    this.loading = false;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.driver-account-page {
    height: 100%;

    .my-16 {
        margin: 16px 0;
    }
}

.dz-page {
    height: calc(100% - 24px);

    :deep(.el-descriptions) {
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }

    :deep(.el-descriptions)::after {
        content: '';
        pointer-events: none;
        position: absolute;
        inset: 0;
        border-radius: 8px;
        border: 1px solid #EBEEF5;
        z-index: 1;
    }
    :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 150px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }
}
</style>
